import type {
  BaseTimeSeriesRecord,
  CreateBulkDevicesRequest,
  CreateBulkDevicesResponse,
  Device,
  DeviceCreateRequest,
  DeviceCreateResponse,
  DeviceGetAllResponse,
  DeviceMetricGetAllParams,
  DeviceMetricGetAllResponse,
  DeviceSearch,
  DeviceUpdateRequest,
  DeviceUpdateResponse,
  MDMStatusResponse,
  PatchCalibrateRequest,
  PatchCalibrateResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class DeviceApi {
  public async getDevices(params: DeviceSearch): Promise<DeviceGetAllResponse> {
    const result = await trpcClient.device.getAll.query(params);

    const { devices, link } = result;

    return {
      devices,
      link,
    };
  }

  createDevice = async (
    device: DeviceCreateRequest,
  ): Promise<DeviceCreateResponse> => {
    return trpcClient.device.create.mutate(device);
  };

  createBulkDevices = async (
    devices: CreateBulkDevicesRequest,
  ): Promise<CreateBulkDevicesResponse> => {
    return trpcClient.device.createBulk.mutate(devices);
  };

  public getDevice = async (id: string): Promise<Device | undefined> => {
    const result = await trpcClient.device.getById.query({ id });

    return result;
  };

  public updateDevice = async (
    id: string,
    device: DeviceUpdateRequest,
  ): Promise<DeviceUpdateResponse> => {
    return trpcClient.device.update.mutate({
      id,
      ...device,
    });
  };

  public calibratePatch = async (
    request: PatchCalibrateRequest,
  ): Promise<PatchCalibrateResponse> => {
    const result = await trpcClient.device.calibratePatch.mutate(request);

    return result;
  };

  public rebootDevice = async (id: string): Promise<void> => {
    await trpcClient.device.reboot.mutate({ id });
  };

  public getMDMStatus = async (id: string): Promise<MDMStatusResponse> => {
    const result = await trpcClient.device.getMDMStatus.mutate({ id });

    return result;
  };

  public getBandStatus = async (
    id: string,
  ): Promise<BaseTimeSeriesRecord[]> => {
    return await trpcClient.device.getBandStatus.mutate({ id });
  };

  public getDeviceMetrics = async (
    params: DeviceMetricGetAllParams,
  ): Promise<DeviceMetricGetAllResponse> => {
    const result = await trpcClient.device.getDeviceMetrics.mutate(params);

    return result;
  };
}
